import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dragMode: false

}

const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        setdragMode: (state, action) => {
            state.dragMode = action.payload;
        },
    }
});




export const {
    setdragMode,
} = layoutSlice.actions;

export default layoutSlice.reducer;
